import React from 'react';

// Actions
import { refreshOmniRiskProfile } from '@/redux/modules/omni-risk-profiles';

// Components
import { FormattedMessageV2 } from '@/views/components/i18n';
import { IconButton } from '@/views/components/buttons';
import { Tooltip } from '@/views/components/tooltips';

// Enums
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';
import { OmniRiskProfileStatus } from '@/enums/OmniRiskProfiles';

// Libraries
import moment from 'moment';
import { Dispatch } from '@/redux';
import { useDispatch, useSelector } from 'react-redux';

// Types
import { FormattedFullOmniRiskProfile } from '@/types/risk-profiles/omni/full-omni-risk-profile';
import { ReduxState } from '@/redux/modules/types';

// Utils
import { formatLocalizedString, formatMessage } from '@/utils/i18n';

interface RiskProfileDetailsProps {
  riskProfile: FormattedFullOmniRiskProfile;
}

export const RiskProfileDetails: React.FC<RiskProfileDetailsProps> = ({ riskProfile }) => {
  const dispatch = useDispatch<Dispatch>();
  const currentContact = useSelector((state: ReduxState) => state.contacts.current?.contact);

  const hideOpenRiskProfileButton =
    riskProfile.status !== OmniRiskProfileStatus.ClientReview && riskProfile.status !== OmniRiskProfileStatus.ClientReviewUnsent;

  const handleOpenRiskProfile = async () => {
    if (riskProfile.status === OmniRiskProfileStatus.Approved) {
      await dispatch(refreshOmniRiskProfile(riskProfile));
    }
    window.location.href = `${riskProfile.omniFormUrl}/review`; // Redirect to OMNI Form for advisor to complete
  };

  return (
    <>
      <hr />
      {!!(currentContact?.fname || currentContact?.lname) && (
        <FormattedMessageV2
          className="label"
          tagName={ALLOWED_HTML_TAGS.P}
          toLocalize="RiskProfileModal.SendQuestionnaire.ToBeReviewedBy"
          values={{ name: `${currentContact?.fname ?? ''} ${currentContact?.lname ?? ''}` }}
        />
      )}
      {riskProfile && (
        <div className="risk-profile-details">
          <h3>{formatLocalizedString(riskProfile.name)}</h3>
          <p>{riskProfile.profile?.title ? formatLocalizedString(riskProfile.profile.title) : '–'}</p>
          <p>{moment(riskProfile.updatedAt).format(formatMessage('Common.DateFormats.DateWithTime'))}</p>
          {hideOpenRiskProfileButton && (
            <Tooltip className="custom-tooltip-v2" message={formatMessage('RiskProfileModal.SendQuestionnaire.OpenRiskProfile')}>
              <IconButton icon="ds-open-in-new" onClick={handleOpenRiskProfile} />
            </Tooltip>
          )}
        </div>
      )}
    </>
  );
};
